import { render, staticRenderFns } from "./CsServicioPresupuesto.vue?vue&type=template&id=6f5c6d06"
import script from "./CsServicioPresupuesto.vue?vue&type=script&lang=js"
export * from "./CsServicioPresupuesto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports